import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { HiCheckCircle, HiMail, HiPhone, HiDocumentText, HiArrowRight } from 'react-icons/hi'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './Join.css'

function Join() {
  const { t } = useTranslation()
  const getLocalizedLink = useLocalizedLink()

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.join'), 'join'),
    [t]
  )

  return (
    <div className="join-page">
      <SEO 
        title={t('join.title', 'Join SUMA International')}
        description={t('join.description', 'Apply to become a member of SUMA International')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="join-hero">
          <h1>{t('join.title', 'Вступить в SUMA International')}</h1>
          <p className="join-intro">
            {t('join.intro', 'Become a member of the International School Union of Martial Arts. Below is how to apply and what membership offers.')}
          </p>
        </div>

        <div className="join-content">
          <div className="join-benefits">
            <h2>{t('join.benefitsTitle', 'Преимущества членства')}</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <HiCheckCircle className="benefit-icon" />
                <h3>{t('join.benefit1', 'Доступ к программам сертификации')}</h3>
                <p>{t('join.benefit1Text', 'Сертификация поясов и рангов для ваших учеников')}</p>
              </div>
              <div className="benefit-item">
                <HiCheckCircle className="benefit-icon" />
                <h3>{t('join.benefit2', 'Участие в мероприятиях')}</h3>
                <p>{t('join.benefit2Text', 'Соревнования, семинары и мастер-классы')}</p>
              </div>
              <div className="benefit-item">
                <HiCheckCircle className="benefit-icon" />
                <h3>{t('join.benefit3', 'Международное признание')}</h3>
                <p>{t('join.benefit3Text', 'Официальное признание и размещение на сайте')}</p>
              </div>
              <div className="benefit-item">
                <HiCheckCircle className="benefit-icon" />
                <h3>{t('join.benefit4', 'Образовательные ресурсы')}</h3>
                <p>{t('join.benefit4Text', 'Доступ к учебным материалам и программам')}</p>
              </div>
            </div>
          </div>

          <div className="join-howto">
            <h2>{t('join.howToTitle', 'Как подать заявку')}</h2>
            <p className="join-howto-intro">{t('join.howToIntro', 'Свяжитесь с нами напрямую — мы ответим на вопросы и подскажем дальнейшие шаги.')}</p>
            <ol className="join-howto-steps">
              <li>{t('join.howToStep1', 'Напишите на sumaunion@yandex.ru: укажите тип организации (школа или федерация), название, контактное лицо, город и страну, дисциплину.')}</li>
              <li>{t('join.howToStep2', 'Или позвоните: +7 (343) 226-99-09 (будни, см. раздел «Контакты» для часов работы).')}</li>
              <li>{t('join.howToStep3', 'Ознакомьтесь с требованиями и материалами в разделе «Документы» перед или после обращения.')}</li>
            </ol>
            <div className="join-actions join-actions--howto">
              <a href="mailto:sumaunion@yandex.ru" className="btn btn-primary">
                <HiMail className="btn-icon" />
                {t('join.emailUs', 'Написать')}
              </a>
              <a href="tel:+73432269909" className="btn btn-secondary">
                <HiPhone className="btn-icon" />
                {t('join.call', 'Позвонить')}
              </a>
              <Link to={getLocalizedLink('/documents')} className="btn btn-secondary">
                <HiDocumentText className="btn-icon" />
                {t('join.viewDocuments', 'Документы')}
                <HiArrowRight className="btn-icon" />
              </Link>
            </div>
          </div>

          <div className="join-info">
            <h2>{t('join.infoTitle', 'Дополнительная информация')}</h2>
            <p>{t('join.infoText', 'После обращения мы рассмотрим запрос и свяжемся с вами в течение нескольких рабочих дней. При необходимости уточним детали по электронной почте или телефону.')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Join
